import { Injectable, OnDestroy } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { CoreConstants, ServiceRouter } from '@pershing/pershing-core';
import { OverviewHoldingsServiceDefinition } from './overview-holdings-service-definition';


@Injectable()
export class OverviewHoldingsService implements OnDestroy {
    holdingServiceUrl: any;

    constructor(private http: HttpClient, private serviceRouter: ServiceRouter) {
        this.holdingServiceUrl = this.serviceRouter.getServiceRouteURL(OverviewHoldingsServiceDefinition.getInstance());
    }

    getHoldingsResponse(context, clientId, quoteType): Observable<any> {
        let headers = new HttpHeaders();
        headers = headers.set('x-accountNumber', clientId);

        const urlPath = this.getGridDataPath(context, clientId);
        let url = urlPath + '?quoteType=' + quoteType + '&isCashIncluded=' + true + '&viewingCurrency=' + 'USD' + '&onlyShortPositions=' + false;
        return this.http.get(url, { headers: headers });
    }
    getModNewsResponse(symbol: any,modnewsurl: any): Observable<any> {
        let urlStart = modnewsurl+"/portal/news";
        let params = [];
        params.push('symbols=' + symbol);
        params.push('format=jsonp');
        params.push('user_id=NXI_API_GOLD_USER');
        let url = urlStart + '?' + params.join('&');
        return this.http.jsonp(url, 'callback');
    }

    private getGridDataPath(context: string, contextId: string) {
        if (context === CoreConstants.ACCOUNT) {
            return this.holdingServiceUrl + `/accounts/${contextId}/positions`;
        } else if (context === CoreConstants.GROUP) {
            return this.holdingServiceUrl + `/groups/${contextId}/positions`;
        } else {
            return '';
        }
    }

    ngOnDestroy() {
        // code here
    }

}